// 企業関連の定数定義

import { BusinessType, EmployeeCountRange } from '../types/company';

// 業種選択肢
export const BUSINESS_TYPE_OPTIONS = [
  { value: BusinessType.SALES_BROKERAGE, label: BusinessType.SALES_BROKERAGE },
  {
    value: BusinessType.RENTAL_BROKERAGE,
    label: BusinessType.RENTAL_BROKERAGE,
  },
  { value: BusinessType.DEVELOPMENT, label: BusinessType.DEVELOPMENT },
  {
    value: BusinessType.PROPERTY_MANAGEMENT,
    label: BusinessType.PROPERTY_MANAGEMENT,
  },
  { value: BusinessType.INVESTMENT, label: BusinessType.INVESTMENT },
  { value: BusinessType.CONSULTING, label: BusinessType.CONSULTING },
  { value: BusinessType.OTHER, label: BusinessType.OTHER },
];

// 従業員数規模選択肢
export const EMPLOYEE_COUNT_RANGE_OPTIONS = [
  { value: EmployeeCountRange.SMALL, label: EmployeeCountRange.SMALL },
  { value: EmployeeCountRange.MEDIUM, label: EmployeeCountRange.MEDIUM },
  { value: EmployeeCountRange.LARGE, label: EmployeeCountRange.LARGE },
  { value: EmployeeCountRange.XLARGE, label: EmployeeCountRange.XLARGE },
];

// 新しいコンポーネント用のエイリアス
export const BUSINESS_TYPES = BUSINESS_TYPE_OPTIONS;
export const EMPLOYEE_COUNT_RANGES = EMPLOYEE_COUNT_RANGE_OPTIONS;

// バリデーション定数
export const VALIDATION_RULES = {
  companyName: {
    maxLength: 100,
    required: true,
  },
  representativeName: {
    maxLength: 50,
    required: true,
  },
  city: {
    maxLength: 50,
    required: true,
  },
  contactEmail: {
    maxLength: 255,
    required: true,
  },
  password: {
    minLength: 8,
    required: true,
  },
} as const;

// エラーメッセージ
export const ERROR_MESSAGES = {
  EMAIL_ALREADY_EXISTS: {
    message: 'このメールアドレスは既に登録されています',
    suggestion:
      'ログインページからサインインするか、別のメールアドレスをお試しください',
    action: '既存アカウントでログイン',
  },
  INVALID_COMPANY_NAME: {
    message: '適切な企業名を入力してください',
    suggestion: '実在する企業名を正式名称で入力してください',
    action: '企業名を修正',
  },
  WEAK_PASSWORD: {
    message: 'パスワードが安全ではありません',
    suggestion: '英数字を含む8文字以上で設定してください',
    action: 'パスワードを強化',
  },
  VALIDATION_ERROR: {
    message: '入力内容に不備があります',
    suggestion: '各項目をご確認の上、再度お試しください',
    action: '入力内容を確認',
  },
} as const;

// フォーム項目のラベル
export const FORM_LABELS = {
  companyName: '企業名',
  representativeName: '代表者氏名',
  prefecture: '所在地（都道府県）',
  city: '所在地（市区町村）',
  businessType: '業種',
  employeeCountRange: '従業員数規模',
  contactEmail: '担当者メールアドレス',
  password: 'パスワード',
  agreedToTerms: '利用規約に同意する',
  agreedToPrivacy: 'プライバシーポリシーに同意する',
} as const;

// プレースホルダー
export const FORM_PLACEHOLDERS = {
  companyName: '例：株式会社○○不動産',
  representativeName: '例：山田 太郎',
  city: '例：新宿区西新宿',
  contactEmail: '例：contact@company.co.jp',
  password: '英数字を含む8文字以上',
} as const;
